/* eslint-disable no-console */
import {Form, Row, Col, Select} from 'antd';
import {useForm} from 'antd/es/form/Form';
import React, {useEffect, useMemo, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {colSpan} from '../../../components/Forms/Constants/IP/FacilityKeyLabel';
import {filterSelectOptions} from '../../../components/Forms/Utils/commonFunctions';
import yearFilterArray from '../../../shared/YearFilterArray';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import {rowGutter} from '../../configurator/orgFacility/Constants/Common';
import {facilitySelectKey} from '../../orgManager/Utils/InfraStructureProfile/constant/facilitySelectConst';
import {sortYearOptions} from '../../orgManager/Utils/InfraStructureProfile/constant/sorYear';

import {
  FilterKey,
  FilterLabel,
  ScopeOptions,
  SubFiltersOptions
} from './common';

const DataLineageFilter: React.FC<{
  selectedYear: string;
  setSelectedYear: (year: string) => void;
  setSelectedFacility: (val: string) => void;
  scope: string;
  setScope: (val: string) => void;
  setSubFilters: (val: string) => void;
  shouldDisable?: boolean;
}> = ({
  selectedYear,
  setSelectedYear,
  setSelectedFacility,
  scope,
  setScope,
  setSubFilters,
  shouldDisable = false
}) => {
  const [form] = useForm();
  const [searchParam] = useSearchParams();
  const facilityDetails = useCompanyStore((s) => s.facilityDetails);
  const [facilities, setFacilities] = useState<any[]>([]);

  const yearOptions = useMemo(
    () => yearFilterArray(facilityDetails, undefined),
    [facilityDetails]
  );

  useEffect(() => {
    setFacilities(
      facilityDetails?.[selectedYear]?.map((item: any) => {
        return {
          label: item.name,
          value: item._id
        };
      })
    );
  }, [facilityDetails, selectedYear]);

  // initialValues only apply on mount; parent sets selectedYear after facility API — sync when it arrives.
  useEffect(() => {
    if (!selectedYear) {
      return;
    }
    form.setFieldsValue({
      [facilitySelectKey.year]: selectedYear
    });
  }, [form, selectedYear]);

  return (
    <Form
      form={form}
      initialValues={{
        [FilterKey.facility]: searchParam.get('facility') ?? undefined,
        [facilitySelectKey.year]: selectedYear || undefined
      }}
    >
      <Row
        gutter={rowGutter}
        style={{marginTop: '1rem', marginLeft: 'auto', marginRight: 'auto'}}
      >
        <Col className="gutter-row" span={colSpan}>
          <Form.Item
            name={facilitySelectKey.year}
            label="Year"
            labelCol={{span: 24}}
          >
            <Select
              placeholder="Year"
              options={sortYearOptions(yearOptions)}
              size="middle"
              onChange={(e) => {
                setSelectedYear(e);
                setSelectedFacility('');
                setScope('');
                setSubFilters('');
                form.setFieldsValue({
                  [FilterKey.facility]: undefined,
                  [FilterKey.scope]: undefined,
                  [FilterKey.subFilters]: undefined
                });
              }}
              disabled={shouldDisable}
            />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={colSpan}>
          <Form.Item
            label={FilterLabel.facility}
            name={FilterKey.facility}
            labelCol={{span: 24}}
          >
            <Select
              placeholder={FilterLabel.facility}
              options={facilities}
              onChange={(e) => {
                setSelectedFacility(e ?? '');
                setScope('');
                setSubFilters('');
                form.setFieldsValue({
                  [FilterKey.scope]: undefined,
                  [FilterKey.subFilters]: undefined
                });
              }}
              size="middle"
              allowClear
              showSearch
              filterOption={filterSelectOptions}
              disabled={shouldDisable}
            />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={colSpan}>
          <Form.Item
            label={FilterLabel.scope}
            name={FilterKey.scope}
            labelCol={{span: 24}}
          >
            <Select
              placeholder={FilterLabel.scope}
              options={ScopeOptions}
              onChange={(e) => {
                setScope(e ?? '');
                setSubFilters('');
                form.setFieldsValue({
                  [FilterKey.subFilters]: undefined
                });
              }}
              size="middle"
              allowClear
              disabled={shouldDisable}
            />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={colSpan}>
          <Form.Item
            label={FilterLabel.subFilters}
            name={FilterKey.subFilters}
            labelCol={{span: 24}}
          >
            <Select
              placeholder={FilterLabel.subFilters}
              options={SubFiltersOptions?.filter(
                (item: any) => item.scope === scope
              )}
              onChange={(e) => {
                setSubFilters(e ?? '');
              }}
              size="middle"
              allowClear
              showSearch
              filterOption={filterSelectOptions}
              disabled={shouldDisable}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default DataLineageFilter;
